import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const SidebarOffcanvas = ({ route, isOpen, setIsOpen,setShow }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setIsOpen(true);
    };

    useEffect(() => {
        if (!isOpen) {
            setIsMenuOpen(false);
        }
    }, [isOpen]);
    const IconComponent = route.icon ;
    return (
        <>
            <div className="menu" onClick={toggleMenu}>
                <div className="menu_item" >
                    <IconComponent className="text-secondary"/>
                    {isOpen && <div className="link_text text-secondary">{route.name}</div>}
                </div>
                {isOpen && (
                    <div
                        className="text-secondary"
                        animate={
                            isMenuOpen
                                ? {
                                    rotate: -90,
                                }
                                : { rotate: 0 }
                        }
                    >
                        {/*<FaAngleDown />*/}
                    </div>
                )}
            </div>{" "}
            {isMenuOpen && (
                <div className="menu_container">
                    {route.subRoutes.map((subRoute, i) => (
                        <div key={i} custom={i} className="bg-light mx-2" style={{borderRadius:"10px"}}>
                            <NavLink to={subRoute.path} className="link "  onClick={() => setShow(false)}>

                                {/*<div className="icon"><TbPointFilled/></div>*/}
                                <div className="link_text">{subRoute.name}</div>
                            </NavLink>
                        </div>
                    ))}
                </div>
            )}{" "}
        </>
    );
};

export default SidebarOffcanvas;
